import { trackEvent } from '$lib/segment/client';

class Friendbuy {
	#show = $state(false);

	get show() {
		return this.#show;
	}

	set show(show: boolean) {
		this.#show = show;

		if (show) {
			sessionStorage.setItem('mill-modal-dismissed', JSON.stringify({ reason: 'friendbuy' }));
			trackEvent('Show friendbuy');
		}
	}
}

export const friendbuy = new Friendbuy();
